import React from "react";

import { InboxContainer } from "./container";

type InboxType = (props: {
    routes: Route[];
    fixedFontSize?: string;
    localization: LocalizationConfig;
    error?: Error;
    commander: unknown;
}) => JSX.Element;

export const Inbox: InboxType = InboxContainer;

(Inbox as React.FC)["displayName"] = "Inbox";
